<template>
  <div>
    <h3 class="mb-3">
      {{ t('proofOfDelivery') }}
    </h3>
    <img class="rounded" :src="image" :alt="t('proofOfDelivery')" />
    <hr class="tracking-divider" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'ProofOfDelivery',
  props: {
    image: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n()

    return {
      t,
    }
  },
})
</script>
